import { render } from "./Spinner.vue?vue&type=template&id=130b972a&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=130b972a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130b972a"]])

export default __exports__